import {
  axiosInstanceForPublicAPI,
  axiosInstanceForTenantAPI,
} from '~/assets/utils/axiosInstance';
import { AttachmentFolder } from '~/services/api/reports/types';

type Result = {
  item: AttachmentFolder | null;
  parent: number | null | undefined;
};

export const findItemAndParent = (
  array: AttachmentFolder,
  id: number | null = null,
  parentArray: AttachmentFolder | null = null,
): Result => {
  if (!Array.isArray(array)) {
    return { item: null, parent: undefined };
  }

  for (let i = 0; i < array.length; i++) {
    const currentItem = array[i];

    if (id === null) {
      // const itemsForDisplay = currentItem.items?.map(
      //   ({ item: items, ...rest }: Result) => ({ items, ...rest }),
      // );
      const { items, ...rest } = currentItem;
      return { item: rest, parent: id };
    }

    if (currentItem?.id === id) {
      return { item: currentItem, parent: parentArray?.id };
    }

    if (
      currentItem?.is_folder &&
      Array.isArray(currentItem.items) &&
      currentItem.items.length > 0
    ) {
      const result = findItemAndParent(currentItem.items, id, currentItem);
      if (result.item) {
        return result;
      }
    }
  }

  return { item: null, parent: undefined };
};

export const getFileExtension = (file: File) =>
  (file.name.split('.').at(-1) || file.type.split('/')[1]);

type DownloadFileProps = {
  url: string;
  name: string;
};

export const downloadFile = async ({
  url,
  name,
}: DownloadFileProps): Promise<void> => {
  const response = await axiosInstanceForPublicAPI().get(url, {
    responseType: 'blob',
  });

  // Create blob link to download
  const downloadUrl = window.URL.createObjectURL(response.data);
  const link = document.createElement('a');
  link.href = downloadUrl;
  link.setAttribute('download', name);

  // Append to html link element page
  document.body.appendChild(link);

  // Start download
  link.click();

  // Clean up and remove the link
  if (link.parentNode) link.parentNode.removeChild(link);
};

type AddAuditLogProps = {
  name: string;
  companySlug: string;
  reportId: string;
};

export const auditLog = async ({
  name,
  companySlug,
  reportId,
}: AddAuditLogProps) => {
  const newdata = {
    activity: `${name}`,
  };
  const response = await axiosInstanceForTenantAPI(companySlug).post(
    `/report/create/download-audit-log/${reportId}`,
    newdata,
  );
  const res = response.data;
  return res;
};
